export default class ValidationException {
    constructor(message, errors) {
        this.name = 'ValidationException';
        this.message = message || 'An unhandled validation error has occured.';
        this.stack = new Error().stack;
        this.errors = errors;
    }
}